import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import {
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  Transition,
} from '@headlessui/react';
import loader from '../../../assets/icons/loaderDark.gif';
import kebabMenu from '../../../assets/icons/General/vertical-dots.svg';

interface IWidgetKebabProps {
  widgetAction: {
    downloadWidget: () => void;
    loading: boolean;
  };
  widgetMeta?: any;
  className?: string;
}

function WidgetKebab({
  className,
  widgetAction,
  widgetMeta,
}: IWidgetKebabProps) {
  const { downloadWidget, loading } = widgetAction;
  return (
    <div data-html2canvas-ignore="true">
      <Menu as="div" className={`relative inline-block text-left ${className}`}>
        <div>
          <MenuButton className="hover:bg-black-100 flex h-8 w-8 cursor-pointer items-center justify-center rounded-md text-sm font-medium text-white focus:outline-hidden">
            {loading ? (
              <img src={loader} className="h-6 w-6" alt="" />
            ) : (
              <img src={kebabMenu} alt="" />
            )}
          </MenuButton>
        </div>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <MenuItems className="border-black-200 absolute right-0 z-10 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-lg border bg-white shadow-[0px_12px_16px_-4px_#10182814] focus:outline-hidden">
            <div className="px-[6px] py-1">
              {(() => {
                // Define a base class for buttons
                const buttonBaseClass =
                  'group flex w-full items-center rounded-md px-2 py-2 text-sm text-black-700';

                return (
                  <>
                    <MenuItem>
                      {({ focus }) => (
                        <button
                          className={`${buttonBaseClass} ${
                            focus ? 'bg-black-100' : ''
                          }`}
                          onClick={downloadWidget}
                        >
                          Export as image
                        </button>
                      )}
                    </MenuItem>

                    {(() => {
                      const link = widgetMeta?.link || widgetMeta?.meta?.link;
                      return link ? (
                        <MenuItem>
                          {({ focus }) => (
                            <Link
                              to={link?.url}
                              className={`${buttonBaseClass} ${
                                focus ? 'bg-black-100' : ''
                              }`}
                            >
                              {link.label}
                            </Link>
                          )}
                        </MenuItem>
                      ) : null;
                    })()}
                  </>
                );
              })()}
            </div>
          </MenuItems>
        </Transition>
      </Menu>
    </div>
  );
}

export default WidgetKebab;
